import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { UserCircle, EnvelopeSimple, Signature, Buildings, ShieldCheck, CheckCircle, WarningCircle, CaretRight } from "@phosphor-icons/react";

export default function SettingsHome() {
  const { user } = useAuth();
  const [account, setAccount] = useState(undefined);

  useEffect(() => { api.get("/crm/email-account").then((r) => setAccount(r.data)).catch(() => setAccount(null)); }, []);

  const emailStatus = account === undefined ? "…" : account ? "connected" : "none";
  const cards = [
    { to: "/app/settings/profile", icon: UserCircle, title: "Mon profil",
      desc: `${user?.name || "—"}${user?.job_title ? " · " + user.job_title : ""}`, cta: "Modifier" },
    { to: "/app/settings/email", icon: EnvelopeSimple, title: "Email professionnel",
      desc: account?.email || "Aucune boîte connectée",
      status: emailStatus === "connected" ? "ok" : emailStatus === "none" ? "warn" : null, cta: "Configurer" },
    { to: "/app/settings/email", icon: Signature, title: "Signature",
      desc: account?.signature_html ? "Configurée" : "Non configurée",
      status: account?.signature_html ? "ok" : "warn", cta: "Modifier" },
    { to: "/app/settings/organization", icon: Buildings, title: "Organisation",
      desc: user?.organization?.name || user?.company || "—", cta: "Voir" },
    { to: "/app/settings/security", icon: ShieldCheck, title: "Sécurité",
      desc: "Mot de passe & session", cta: "Gérer" },
  ];

  return (
    <div data-testid="settings-home">
      <h1 className="font-display text-3xl font-bold">Réglages</h1>
      <p className="text-muted text-sm mt-1 mb-7">Gérez votre identité, votre email professionnel, votre signature et votre sécurité.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <Link key={c.title} to={c.to} data-testid={`settings-card-${c.title.split(' ')[0].toLowerCase()}`}
              className="surface rounded-lg p-5 hover-lift flex items-start gap-4 group">
              <div className="w-11 h-11 rounded-md bg-accent/10 border border-accent/25 flex items-center justify-center shrink-0">
                <Icon size={20} weight="duotone" className="text-accent" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="font-display font-bold text-fg flex items-center gap-2">{c.title}
                  {c.status === "ok" && <CheckCircle size={14} weight="fill" className="text-accent" />}
                  {c.status === "warn" && <WarningCircle size={14} weight="fill" className="text-[#F5A623]" />}
                </div>
                <div className="text-sm text-muted truncate mt-0.5">{c.desc}</div>
                <span className="text-xs text-accent mt-2 inline-flex items-center gap-1 group-hover:gap-1.5 transition-all">{c.cta} <CaretRight size={11} /></span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
